import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <i className="fas fa-compress-alt"></i>
          <h1>File Compression Tool</h1>
        </div>
        <div className="header-info">
          <span className="algorithm-badge">Huffman</span>
          <span className="algorithm-badge">LZW</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
